import React from 'react'

/** Hero icon — fixed-size PDF ring + react-icons/fa glyph (matches rest of site) */
export default function HeroIcon({ icon: Icon, label }) {
  return (
    <div className="hero-icon" role="img" aria-label={label}>
      <div className="hero-icon__ring">
        <Icon className="hero-icon__glyph" aria-hidden="true" />
      </div>
    </div>
  )
}
